import "../Css/Main.css";
import mobileapp from "../Assets/Images/AppImage.png";
import { Link } from "react-router-dom";

const AppDevHome = () => {
  return (
    <div className="bg-night web3-grid-bg pt-10 relative overflow-hidden">
      <div className="glow-orb w-[380px] h-[380px] bg-neonPurple/25 -top-24 -left-24"></div>
      <div className="glow-orb w-[320px] h-[320px] bg-customRed/20 bottom-0 right-0"></div>
      <div className="max-w-[1240px] mx-auto py-20 sm:py-28 lg:py-40 p-4 relative">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 place-items-center">
          <div className="order-2 lg:order-1">
            <h1 className="text-2xl sm:text-3xl font-extrabold text-white">
              MOBILE APP DEVELOPMENT SERVICES BY SPACEXPAKISTAN
            </h1>
            <p className="text-base sm:text-lg lg:text-xl py-4 sm:py-5 text-white">
              SpaceXPakistan is a mobile app development firm that specializes in
              creating high-performance, feature-packed, and resilient mobile
              applications for both iOS and Android platforms.
            </p>
            <p className="text-base sm:text-lg lg:text-xl text-white">
              With proficiency in developing cross-platform applications, the
              company ensures compatibility across various operating systems.
            </p>
            <Link to="/contactUs">
              <button
                type="button"
                className="text-white my-5 bg-customRed neon-btn cursor-pointer focus:outline-none font-bold rounded-full text-lg px-5 py-2 hover:scale-110 transition ease-in-out text-center"
              >
                Get Free Consultation
              </button>
            </Link>
          </div>
          <div className="order-1 lg:order-2 w-full flex justify-center">
            <img
              className="w-full max-w-lg h-auto max-h-[240px] sm:max-h-[360px] lg:max-h-[380px] object-contain"
              src={mobileapp}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDevHome;
